// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"28918627","437":"28918627","444":"28918627","645":"28918627","820":"28918627","921":"28918627","983":"28918627"}[chunkId] + ".chunk.css";
};